import { toTimeAgo } from "Common/dateTimeUtils/format";
import Menu from "Components/menu";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import compact from "lodash/compact";
import React, { useMemo } from "react";
import locale from "./summaryReportWithPreviewImage.locale";
import DocumentPreviewImage from "Areas/SharedFeatures/documentPreviewImage";
import styles from "./summaryReportWithPreviewImage.module.css";
const SIZES = {
    MENU_TOGGLER_SIZE: 26
};
export default function SummaryReportWithPreviewImage({ summaryReport, className, onOpenEditorPanel, onDelete, getSummaryReportDetailsHref, width, height, canEdit, canDelete }) {
    const summaryReportDetailsHref = useMemo(() => getSummaryReportDetailsHref &&
        getSummaryReportDetailsHref(summaryReport.Id, summaryReport.ProjectId), [getSummaryReportDetailsHref, summaryReport.Id, summaryReport.ProjectId]);
    const menuItems = useMemo(() => compact([
        summaryReportDetailsHref && {
            text: locale.OPEN,
            onClick: () => {
                if (summaryReportDetailsHref) {
                    window.location.href = summaryReportDetailsHref;
                }
            }
        },
        summaryReportDetailsHref && {
            divider: true
        },
        canEdit && {
            text: locale.EDIT,
            onClick: () => {
                summaryReport && onOpenEditorPanel && onOpenEditorPanel(summaryReport.Id);
            }
        },
        canDelete && {
            text: locale.DELETE,
            confirm: {
                title: locale.CONFIRM_DELETE_TEXT,
                header: locale.CONFIRM_DELETE_HEADER,
                callback: () => {
                    onDelete && onDelete(summaryReport.Id);
                }
            }
        }
    ]), [summaryReport, summaryReportDetailsHref]);
    const name = useMemo(() => React.createElement(summaryReportDetailsHref ? "a" : "div", {
        href: summaryReportDetailsHref,
        className: "d-block no-text-decoration w-100-max font-bold text-gray-600 text-overflow-ellipsis nowrap"
    }, summaryReport.Name), [summaryReportDetailsHref]);
    const containerStyle = useMemo(() => ({
        border: `1px solid ${themeVariables["page-header-border-color"]}`,
        width,
        height
    }), [width, height]);
    return (React.createElement("div", { className: classNames("grid-rows-1fr-auto overflow-hidden border-rounded-base", styles.card, className), style: containerStyle },
        React.createElement(summaryReportDetailsHref ? "a" : "div", {
            href: summaryReportDetailsHref,
            className: classNames("no-text-decoration line-height-1 border-rounded-medium-top-left border-rounded-medium-top-right")
        }, React.createElement(DocumentPreviewImage, { documentType: 5, width: width })),
        React.createElement("div", { className: "caption-with-actions-panel with-gap-xxs pl-0_75 pr-0_75 pt-0_25 pb-0_25" },
            React.createElement("div", { className: "overflow-hidden" },
                name,
                React.createElement("div", { className: "w-100-max font-h6 text-gray-300 text-overflow-ellipsis nowrap" }, toTimeAgo(summaryReport.Created))),
            React.createElement(Menu, { togglerClassName: "menu-toggle-btn-text", togglerHeight: SIZES.MENU_TOGGLER_SIZE, togglerWidth: SIZES.MENU_TOGGLER_SIZE, togglerIconClassName: "icon-dots menu-toggle-btn-text-icon", items: menuItems }))));
}
SummaryReportWithPreviewImage.defaultProps = {
    height: 147,
    width: 260
};
